import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyC2tI301kva-Sx3p6OJHYN0JKfVE27paTI",
  authDomain: "playground-directory-eb06b.firebaseapp.com",
  projectId: "playground-directory-eb06b",
  storageBucket: "playground-directory-eb06b.firebasestorage.app",
  messagingSenderId: "1030443924684",
  appId: "1:1030443924684:web:f5240d51b302971ef39669",
  measurementId: "G-KQLRNGTKYD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app;